import React from "react";

const Text = ({ children, className = "" }) => {
  return <span className={className}>{children}</span>;
};

export default Text;